import React from 'react';
import { hydrate } from 'react-dom';
import { Provider } from 'react-redux';
import { IntlProvider, addLocaleData } from 'react-intl';
import serverVars from 'server-vars';
import { actionCreators } from '../actions';
import { footerRootQuery, footerInitialVariables, FooterRenderer } from '../components/footer';

const getBuyerFooterClient = ({ node, store, relayEnv }) => {
    const localeDataKey = serverVars.get('localeDataKey');
    const messages = serverVars.get('messages');

    if (window.ReactIntlLocaleData) {
        addLocaleData(window.ReactIntlLocaleData[localeDataKey]);
    }

    hydrate(
        <IntlProvider locale={localeDataKey} messages={messages}>
            <Provider store={store}>
                <FooterRenderer
                    environment={relayEnv}
                    initialVariables={footerInitialVariables}
                    query={footerRootQuery}
                />
            </Provider>
        </IntlProvider>,
        node
    );

    return {
        updateUserState: store.dispatch.bind(null, actionCreators.setUpdateUserState(true)),
    };
};

export { getBuyerFooterClient };
